import { useTranslation } from 'react-i18next'
import { cn } from '@/lib/utils'
import { statusLabel, type StatusTone } from '@/lib/statusLabel'

interface ProjectStatusBadgeProps {
  status?: string | null
  className?: string
}

const toneClass: Record<StatusTone, string> = {
  success: 'bg-emerald-100 text-emerald-800 dark:bg-emerald-500/20 dark:text-emerald-300',
  running: 'bg-blue-100 text-blue-800 dark:bg-blue-500/20 dark:text-blue-300',
  warning: 'bg-amber-100 text-amber-800 dark:bg-amber-500/20 dark:text-amber-300',
  danger: 'bg-red-100 text-red-800 dark:bg-red-500/20 dark:text-red-300',
  partial: 'bg-violet-100 text-violet-800 dark:bg-violet-500/20 dark:text-violet-300',
  muted: 'bg-gray-200 text-gray-700 dark:bg-gray-500/20 dark:text-gray-300',
  unknown: 'bg-muted text-muted-foreground',
}

export function ProjectStatusBadge({ status, className }: ProjectStatusBadgeProps) {
  const { t } = useTranslation()
  const visual = statusLabel(status, 'project')
  const label = t(visual.textKey, visual.textOptions)

  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium',
        toneClass[visual.tone],
        className,
      )}
    >
      {label}
    </span>
  )
}
